import React from 'react';

const YOUTUBE_LOGO_URL =
  'https://www.gstatic.com/youtube/img/branding/youtubelogo/svg/youtubelogo.svg';

type YouTubeApiServicesNoticeProps = {
  className?: string;
  variant?: 'default' | 'footer';
};

export function YouTubeApiServicesNotice({
  className = 'text-xs text-gray-500',
  variant = 'default',
}: YouTubeApiServicesNoticeProps) {
  const linkClass =
    variant === 'footer'
      ? 'text-[#cbe3e2] underline underline-offset-2 hover:text-white'
      : 'text-[#1a5172] underline underline-offset-2 hover:text-[#164a65]';

  if (variant === 'footer') {
    return (
      <div className="flex max-w-xl flex-col items-center gap-2 px-4 text-center text-xs text-[#cbe3e2]">
        <p>Video suggestions use YouTube API Services.</p>
        <a
          href="https://www.youtube.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center"
          aria-label="YouTube"
        >
          <img src={YOUTUBE_LOGO_URL} alt="YouTube" width={120} height={28} className="h-7 w-auto" />
        </a>
        <p>
          By using video features, you agree to the{' '}
          <a
            href="https://www.youtube.com/t/terms"
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
          >
            YouTube Terms of Service
          </a>
          .
        </p>
      </div>
    );
  }

  return (
    <p className={className}>
      Video suggestions use{' '}
      <a
        href="https://developers.google.com/youtube/terms/api-services-terms-of-service"
        target="_blank"
        rel="noopener noreferrer"
        className={linkClass}
      >
        YouTube API Services
      </a>
      . By using video materials, you agree to the{' '}
      <a
        href="https://www.youtube.com/t/terms"
        target="_blank"
        rel="noopener noreferrer"
        className={linkClass}
      >
        YouTube Terms of Service
      </a>
      .
    </p>
  );
}
